import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { TipoEntidadeEnum } from "resources/enums/conta";
import { useEffect } from "react";
import { usePrevious } from "@chakra-ui/hooks";
import { useDebounce } from "features/shared/useDebouce";
import { diff } from "deep-object-diff";
import { PessoaTipo } from "features/pessoas/typings";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { TipoUnidadePessoaEnum } from "core/features/unidades/typings/unidade";
import ModalCadastroPessoa from "../SelectPessoas/ModalCadastroPessoa";
import { useFornecedores } from "core/features/fornecedores/hooks";
import { queryClient } from "infra/packages/react-query";
import { PaginateResult } from "core/resources/types/shared";
import { FornecedorItemResponse } from "core/features/fornecedores/typings";

export interface SelectPessoasProps<T = any> extends SelectBaseAntdProps<T> {
  value: any;
  unidadeId?: string | string[];
  tipoPessoa?: PessoaTipo;
  tenantId?: string | null;
  tipoEntidades?: TipoEntidadeEnum[];
  tipoUnidadePessoa?: TipoUnidadePessoaEnum[];
  isInvalid?: boolean;
  semDocumentoDuplicado?: boolean;
  somenteComDocumento?: boolean;
  filteredOptions?: string[];
  incluirPessoasComUnidade?: boolean;
  prependOptions?: {
    label: string;
    value: string;
  }[];
}

function SelectPessoaFornecedora({
  value,
  tenantId,
  unidadeId,
  onChange,
  isInvalid,
  tipoEntidades,
  tipoUnidadePessoa,
  filteredOptions,
  tipoPessoa,
  incluirPessoasComUnidade,
  prependOptions,
  semDocumentoDuplicado,
  somenteComDocumento,
  ...rest
}: SelectPessoasProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [search, setSearch] = useState<string>();

  const debouncedSearchTerm = useDebounce(search, 500);

  const tipoEntidadeValue = usePrevious(tipoEntidades);

  const { data, isFetching, isLoading } = useFornecedores({
    page: 1,
    search: debouncedSearchTerm,
  });

  useEffect(() => {
    if (!tipoEntidades || !tipoEntidadeValue) {
      return;
    }

    const isDiff = Object.keys(diff(tipoEntidades, tipoEntidadeValue)).length;

    if (typeof onChange === "function" && isDiff && !isFetching) {
      onChange(undefined, {} as any);
    }
  }, [tipoEntidades, onChange, tipoEntidadeValue, isFetching]);

  const getOptions: () => { label: string; value: string }[] = () => {
    const options = [];

    let _items =
      data?.items.filter((item) =>
        filteredOptions ? !filteredOptions.includes(item.id) : true,
      ) ?? [];

    if (prependOptions) {
      options.push(...prependOptions);

      _items = _items?.filter(
        (i) => !prependOptions.find((o) => o.value === i.id),
      );
    }

    if (data?.items) {
      options.push(
        ..._items?.map((item) => ({
          label: item.nome,
          value: item.pessoaId,
        })),
      );
    }

    return options;
  };
  function insertItemIntoQUeryAndSelectIt({
    id,
    nome,
  }: {
    id: string;
    nome: string;
  }) {
    // ao adicionat um novo fornecedor via moda
    //  insere ele na query de fornecedores e seleciona ele em seguida
    queryClient.setQueriesData(
      [
        `/v1/fornecedor`,
        {
          page: 1,
          search: debouncedSearchTerm,
        },
      ],
      (oldData: unknown) => {
        const OLD_DATA = oldData as PaginateResult<FornecedorItemResponse>;
        if (oldData) {
          OLD_DATA.items.push({
            id,
            nome,
            pessoaId: id,
          } as unknown as FornecedorItemResponse);
          return JSON.parse(JSON.stringify(OLD_DATA));
        }
      },
    );
    setTimeout(() => {
      // para garantir que houve update do state da query antes de selecionar
      onChange?.(id, {
        value: id,
        label: nome,
      });
    }, 100);
  }
  return (
    <>
      {isOpenModal ? (
        <ModalCadastroPessoa
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSaved={insertItemIntoQUeryAndSelectIt}
        />
      ) : null}
      <SelectBaseAntd
        loading={isLoading}
        isInvalid={isInvalid}
        size="large"
        showSearch
        placeholder="Selecione..."
        searchValue={search}
        onSearch={setSearch}
        onChange={onChange}
        value={value}
        filterOption={() => true}
        options={getOptions()}
        allowClear
        {...rest}
        notFoundContent={
          !isFetching ? (
            <Box>
              Nenhuma pessoa encontrada para essa busca
              <Button
                isLoading={false}
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar nova
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectPessoaFornecedora;
